import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'i18n';
import Head from 'next/head';
import globe from 'static/assets/images/globe.png';

const GoogleTranslate = ({
  t,
  locale,
  fontFamily,
  googleTranslateIntegration,
  nonce,
}) => {
  return (
    <div id="google-translate-element">
      <Head>
        <script
          nonce={nonce}
          type="text/javascript"
          dangerouslySetInnerHTML={{
            __html: `
              function startGoogleTranslation () {
                new google.translate.TranslateElement({
                  pageLanguage: '${locale || 'en'}',
                  includedLanguages: '${
                    googleTranslateIntegration.includedLanguages || ''
                  }'
                }, 'google-translate-element')
              }`,
          }}
        />
        <script
          nonce={nonce}
          src="https://translate.google.com/translate_a/element.js?cb=startGoogleTranslation"
          async
        />
      </Head>
      <img
        src={globe}
        alt={t('marketplace:marketplace.googleTranslateImage')}
      />
      <style>
        {`
          #google-translate-element {
            display: flex;
            align-items: center;
            min-width: 145px;
            max-height: 32px !important;
            background-color: #e8eaed;
            overflow: hidden;
            padding-left: 5px;
            padding-right: 5px;
            margin-left: ${
              googleTranslateIntegration.position === 'right'
                ? 'auto'
                : 'initial'
            };
          }
          #google-translate-element:focus-within {
            outline: 1px solid;
          }
          #google-translate-element .skiptranslate {
            display: flex;
            color: #e8eaed;
            margin-left: 4px;
            max-width: 124px !important;
          }
          #google-translate-element .skiptranslate span {
            display: none;
          }
          #google-translate-element .skiptranslate select {
            color: #262626 !important;
            cursor: pointer;
            background-color: #e8eaed;
            padding: 0 !important;
            appearance: none;
            -moz-appearance: none;
            -webkit-appearance: none;
            border-color: #e8eaed;
            font-family: ${fontFamily};
          }
          #google-translate-element .skiptranslate select:focus {
            outline: transparent;
          }
          #google-translate-element .skiptranslate select::-ms-expand {
            display: none;
          }
          #google-translate-element .goog-te-gadget .goog-te-combo {
            margin: 5px 0 !important;
          }
        `}
      </style>
    </div>
  );
};

GoogleTranslate.propTypes = {
  locale: PropTypes.string,
  t: PropTypes.func.isRequired,
  fontFamily: PropTypes.string,
  googleTranslateIntegration: PropTypes.object,
};

export default withTranslation(['marketplace'])(GoogleTranslate);
